var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLooksrareBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4342 34.9106C40.1355 25.2642 55.8644 25.2642 65.5658 34.9106L73.9459 43.2433L65.5658 51.576C55.8645 61.2225 40.1355 61.2225 30.4342 51.576L22.0541 43.2433L30.4342 34.9106Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 43.2569L35.027 24.2168H60.9729L79.9999 43.2569L47.9999 75.2437L16 43.2569ZM62.7026 36.3245C54.6181 28.2046 41.3817 28.2046 33.2972 36.3246L26.3783 43.2436L33.2972 50.1625C41.3817 58.2824 54.6181 58.2824 62.7026 50.1625L69.6215 43.2436L62.7026 36.3245Z",
    fill: "#0CE466"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 49.2975C44.6577 49.2975 41.9459 46.5884 41.9459 43.2435C41.9459 39.8986 44.6577 37.1895 47.9999 37.1895C51.3421 37.1895 54.054 39.8986 54.054 43.2435C54.054 46.5884 51.3421 49.2975 47.9999 49.2975Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0541 43.2428C38.0541 48.738 42.5093 53.1887 48 53.1887C53.4907 53.1887 57.9459 48.738 57.9459 43.2428C57.9459 37.7476 53.4907 33.2969 48 33.2969C42.5093 33.2969 38.0541 37.7476 38.0541 43.2428ZM43.6757 43.2428C43.6757 45.632 45.6127 47.5671 48 47.5671C50.3872 47.5671 52.3243 45.632 52.3243 43.2428C52.3243 40.8536 50.3872 38.9185 48 38.9185C45.6127 38.9185 43.6757 40.8536 43.6757 43.2428Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLooksrareBlack);
export default __webpack_public_path__ + "static/media/looksrare-black.f7c2b695f3f8f1489c85166db7053e5e.svg";
export { ForwardRef as ReactComponent };